import { GlowIcon } from '@/common/assets';

export default function Glow() {
  return (
    <div
      className="pointer-events-none absolute left-[14px] top-[18px] z-2 h-[35px] w-[45px] blur-[3px]"
      aria-hidden
    >
      <img
        src={GlowIcon}
        alt="Card glow"
        className="pointer-events-none absolute inset-0 h-full w-full max-w-none object-cover object-top"
        draggable={false}
      />
    </div>
  );
}
